export default {
    'en-US': {
      popOver: {
        adminOnly: 'Admin Only'
      }
    }
  }
  